var React = require('react');

function LeftInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t\t.st0 {\n\t\t\tfill: currentColor;\n\t\t}\n\t"),React.createElement("path",{"className":"st0","d":"M32.3,6.4H10.1C9.9,6.4,9.7,6.2,9.7,6V1.5c0-0.6-0.3-1.2-0.9-1.4C8.3-0.1,7.7,0,7.3,0.4L0.4,7.6\n\tc-0.6,0.6-0.6,1.5,0,2.1l6.9,7.1c0.3,0.3,0.6,0.4,1,0.4c0.8,0,1.4-0.7,1.4-1.5v-4.5c0-0.2,0.2-0.4,0.4-0.4h22.2c1.2,0,2.2-1,2.2-2.2\n\tC34.5,7.4,33.5,6.4,32.3,6.4z","key":1})]);
}

LeftInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 34.5 17.3","style":{"enableBackground":"new 0 0 34.5 17.3"},"xmlSpace":"preserve"};

module.exports = LeftInline;

LeftInline.default = LeftInline;
